// import {PopupFacade} from '../popup/popupFacade';
import axios from 'axios';

class ConstructorWidget {
    /* eslint-disable max-statements */
    constructor(options) {
        this.element = options.element;
        this.token = options.token;
        this.id = this.element.dataset?.id;
        this.widgetElement = this.element.dataset?.widgetId;
        this.layout = this.element.dataset?.layout;
        this.popup = this.element.dataset?.popup;
        this.popupFlatButton = document.querySelector('.j-constructor__flat');
        this.attempts = 0;
        this.data = {};
        this.clearBtn = document.querySelector('.j-widget-clear');
        this.showBtn = document.querySelector('.j-widget-show');
        this.isTest = false;
        this.isProd = false;
        this.stage = 'prod';
        this.action = this.element.dataset.action || '/tests/plans.json';
        this.flat = document.querySelector('.j-flat-result') || null;
        this.image = this.flat.querySelector('.j-flat__image') || null;
        this.pdf = this.flat.querySelector('.j-flat__pdf') || null;
        this.area = this.flat.querySelector('.j-flat-area');
        this.areaOption = this.flat.querySelector('.j-flat-whole-area');
        this.planName = this.flat.querySelector('.j-flat-plan-name');
        this.button = this.flat.querySelector('.j-popup');
        this._init();
    }
    /* eslint-enable max-statements */

    _init() {
        this._checkTestOrProd();
        this.#getInfo();
        this.#insertWidget();
        this.#initWidget();
    }

    /**
     * Проверяем площадку по урлу. Для теста - свой токен и свои пути к файлам
     */
    _checkTestOrProd() {
        this.isTest = window.location.href.includes('test');
        this.isProd = window.location.host.includes('house');

        if (this.isTest) {
            this.stage = 'test';
        } else if (this.isProd) {
            this.stage = 'prod';
        } else {
            this.stage = 'stage';
        }
    }

    /**
     * Получаем данные по квартире
     */
    #getInfo() {
        this.data.number = this.element.dataset?.number;
        this.data.plan = this.element.dataset?.plan;
        this.data.area = this.element.dataset?.area;
        this.data.price = this.element.dataset?.price;
    }

    /**
     * Подставляем скрипты виджета если его нет на странице
     */
    #insertWidget() {
        if (window.LayoutBuilder) {
            return;
        }

        const widgetStyles = document.createElement('link');
        const widgetFonts = document.createElement('link');
        const widgetScripts = document.createElement('script');

        const stylesPath = `https://storage.yandexcloud.net/kp-widget-${this.stage}/layout-builder.css`;
        const fontsPath = `https://storage.yandexcloud.net/kp-widget-${this.stage}/fonts.css`;
        const jsPath = `https://storage.yandexcloud.net/kp-widget-${this.stage}/layout-builder.js`;

        widgetStyles.setAttribute('rel', 'stylesheet');
        widgetStyles.setAttribute('href', stylesPath);
        document.head.appendChild(widgetStyles);

        widgetFonts.setAttribute('rel', 'stylesheet');
        widgetFonts.setAttribute('href', fontsPath);
        document.head.appendChild(widgetFonts);

        widgetScripts.setAttribute('src', jsPath);
        widgetScripts.setAttribute('type', 'module');
        document.head.appendChild(widgetScripts);

        if (this.attempts < 5) {
            setTimeout(() => {
                this.#initWidget();
            }, 1000);
        }
    }

    /**
     * Initializes the widget.
     */
    #initWidget() {
        if (!window.LayoutBuilder) {
            setTimeout(() => {
                this.attempts++;
                this.#insertWidget();
            }, 1000);

            return;
        }

        let url = '';

        if (this.isTest) {
            url = 'https://api.testing.planner.kortros.ru';
        } else if (this.isProd) {
            url = 'https://api.planner.kortros.ru';
        } else {
            url = 'https://api.stage.planner.kortros.ru';
        }

        window.LayoutBuilder.init({
            elementId: this.widgetElement,
            apiUrl   : url,
            token    : this.token
        });

        this.#initButtonEvent();

        if (!this.popup) {
            return;
        }

        window.LayoutBuilder.onSave(() => {
            // const popupButtons = [...document.querySelectorAll('.j-constructor__result-popup')];
            // const options = {
            //     ...{openButtons: popupButtons}
            // };
            // const facade = new PopupFacade(options);
            // facade.init();

            const saved = window.LayoutBuilder?.getSaved()[0];
            const formData = new FormData();

            formData.append('layoutCode', saved.subtypeName);
            formData.append('premiseId', this.id);

            this._send(formData, saved);
        });
    }

    fulfillFlatResult(data, flatData) {
        if (!this.flat) {
            return;
        }

        this.area.innerHTML = data.area;
        this.areaOption.innerHTML = data.area;
        this.planName.innerHTML = data.subtypeName;
        this.image.src = flatData.plan;
        this.pdf.href = flatData.pdfLink;
        this.button.dataset.flatPlan = flatData.layoutId;
    }

    _send(formData, saved) {
        axios.post(this.action, formData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    const flatData = response.data.data;

                    if (flatData) {
                        this.fulfillFlatResult(saved, flatData);
                        this.popupFlatButton.click();
                    }
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    showToast(message) {
        const toastContainer = document.getElementById('toast-container');

        if (!toastContainer) {
            return;
        }

        toastContainer.innerText = message;
        toastContainer.style.display = 'block';

        setTimeout(() => {
            toastContainer.style.display = 'none';
        }, 5000);
    }

    #initButtonEvent() {
        this.element.addEventListener('click', () => {
            window.LayoutBuilder?.clearSaved();
            window.LayoutBuilder.show(this.layout, this.data);
        });

        if (this.clearBtn) {
            this.clearBtn.addEventListener('click', () => {
                window.LayoutBuilder?.clearSaved();
                this.showToast(`Сохранённые планировки удалены из LocalStorage.`);
            });
        }
    }
}

export default ConstructorWidget;
